import React, { useEffect, useState } from "react";
import Footer from "../../layout/Footer";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import AgentFiltter from "./AgentFiltter";
import { agentColumns } from "../../tables/agentColumns";
import AdminDataTable from "../../components/common/AdminDataTable";
import { can } from "../../utils/can";
import AdharView from "./AdharView";





export default function ViewAgent() {
    const PAGE_SIZE = 10;
    const [sortBy, setSortBy] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState("desc");
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [listLoading, setListLoading] = useState(false);
    const token = localStorage.getItem("adminToken");
    const [agents, setAgents] = useState([]);
    const [filters, setFilters] = useState({});
    const [isOpen, setIsOpen] = React.useState(false);
    const [selectedAgent, setSelectedAgent] = React.useState(null);

    console.log("agents", agents);

    const API_URL = process.env.REACT_APP_BASE_URL_API || "";

    const fetchAgents = async (pageNumber = 1, appliedFilters = filters) => {
        setListLoading(true);
        try {
            const queryParams = new URLSearchParams({
                            page: pageNumber,
                            limit: pageSize,
                            sortBy,
                            sortOrder,
                            ...appliedFilters,
                            }).toString();
            const url = `${API_URL}/api/admin/agents?${queryParams}`;
                            
            
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            if (!response.ok) {
                throw new Error("Failed to fetch agents");
            }

            const data = await response.json();
            setAgents(data.data);
            setTotalPages(Math.ceil(data.totalCount / pageSize));

            setListLoading(false);
        } catch (error) {
            console.error("Error fetching agents:", error);
            setListLoading(false);
        }
    };
         const handleFilter = (newFilters) => {
               
                setFilters(newFilters);
                setPage(1);
                fetchAgents(1, newFilters);
            };

    const handleDelete = async (id) => {
            if (can("view_agent", "delete") === false) {
                alert("You don't have permission to delete agents.");
                return;
            }

            const confirmDelete = window.confirm("Are you sure you want to delete this agent?");
            if (!confirmDelete) return;

            try {
                const response = await fetch(
                    `${API_URL}/api/admin/agents/delete/${id}`,
                    {
                        method: "DELETE",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        }
                    }
                );

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || "Delete failed");
                }

                alert("Agent deleted successfully!");
                fetchAgents(); // refresh list

            } catch (error) {
                console.error("Delete error:", error);
                alert(error.message);
            }
        };

    const handleEdit = (row) => {
        console.log(row);
    }

    const openModal = (agent) => {
        setSelectedAgent(agent);
        setIsOpen(true);
        };

    const closeModal = () => setIsOpen(false);

    const columns = agentColumns({ handleEdit, handleDelete, pageSize, openModal });

    useEffect(() => {
         fetchAgents(page, filters);
    }, [page, sortBy, sortOrder, pageSize]);

    return (
        <div class="container body">
            <div class="main_container">
                <Sidebar />
                <Header pageTitle="View Agent" />

                <>
                    {/* page content */}
                    <div className="right_col" role="main">
                        {/* top tiles */}
                      
                        {/* /top tiles */}
                        {/* body card start */}
                        <div className="x_panel">
                            <div className="x_title">
                                <h2>List</h2>
                                <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                                    <li>
                                        <a className="collapse-link">
                                            <i className="fa fa-chevron-up" />
                                        </a>
                                    </li>


                                </ul>
                                <div className="clearfix" />
                            </div>
                            <div className="x_content">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <AgentFiltter onFilter={handleFilter}  />

                                        {/* filter end */}
                                        <AdminDataTable
                                            columns={columns}
                                            data={agents}
                                            loading={listLoading}
                                            page={page}
                                            pageSize={pageSize}
                                            totalPages={totalPages}
                                            onPageChange={setPage}
                                            onPageSizeChange={(size) => {
                                            setPageSize(size);
                                            setPage(1);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    {/* /page content */}
                    <AdharView
                            agentData={selectedAgent}
                            isOpen={isOpen}
                            closePopup={closeModal}
                            />
                </>


                <Footer />
            </div>
        </div>
    )
}